// extracted by mini-css-extract-plugin
export default {"Container":"Terms_Container__djmyG","Title":"Terms_Title__dULDo","Subtitle":"Terms_Subtitle__7skDr","Section":"Terms_Section__0tU-v","SectionTitle":"Terms_SectionTitle__z84iK"};